<template>
  <ul :class="listClassName">
    <li
      v-for="(item, key) in items"
      :key="key"
      :class="listItemClassName"
    >
      <div
        class="row items-center sm:items-start relative flex-grow-1 content-start sm:px-1 lg:px-0"
      >
        <!-- image -->
        <div class="col-3 sm:col-12">
          <div class="embed-responsive mb-0 rounded-sm">
            <RemoteImage
              :src="`https://img.mix.it/general_assets/categories/${item.image}`"
              img-class="embed-responsive-item relative image-contain"
              :alt="item.text"
            />
          </div>
        </div>
        <!-- text -->
        <div class="col sm:col-12 static sm:pt-1 lg:pt-2 static sm:text-center">
          <!-- Redirect mixit bars and bags from mixes to products -->
          <router-link
            v-if="item.kind === 'mixit_bars' || item.kind === 'fruit_bags'"
            :to="{ name: 'productsPath', params: { permalink: item.permalink } }"
            class="block stretched-link font-medium underline-hover leading-sm"
          >
            {{ item.text }}
          </router-link>
          <router-link
            v-else
            :to="{ name: item.name, params: { permalink: item.permalink } }"
            class="block stretched-link font-medium underline-hover leading-sm"
          >
            {{ item.text }}
          </router-link>
        </div>
        <!-- arrow icon -->
        <div class="col-auto sm:hidden">
          <i class="mi-chevron-r" />
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import RemoteImage from '@/components/general/BaseRemoteImage.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },

  id: {
    type: String,
    required: true,
    validator: (value) => {
      return ['mix', 'ready'].includes(value)
    },
  },
})
const listClassName =
  props.id === 'mix'
    ? 'row no-gutters mt-n2 sm:mt-n4 md:mt-n5 ml-n2 sm:ml-n4 md:ml-n5 lg:mt-n6 lg:ml-n6 xl:ml-n7 py-1 md:py-2 lg:py-3 mb-0 list-unstyled'
    : 'row no-gutters mt-n2 sm:mt-n4 md:mt-n5 lg:mt-n6 ml-n2 sm:ml-n4 md:ml-n5 py-1 md:py-2 lg:py-3 mb-0 list-unstyled'

const listItemClassName =
  props.id === 'mix'
    ? 'col-12 sm:col-4 md:col-3 xl:col-2 flex flex-col pt-2 sm:pt-4 md:pt-5 pl-2 sm:pl-4 md:pl-5 lg:pl-6 xl:pl-7'
    : 'col-12 sm:col-4 md:col-3 lg:col-2 col-17 flex flex-col pt-2 sm:pt-4 md:pt-5 lg:pt-6 pl-2 sm:pl-4 md:pl-5'
</script>

<style lang="scss">
@include media-breakpoint-up(xl){
	//7 na radek
	.col-17{
		@include make-col(math.div(12, 8), $grid-columns);
	}
}
</style>
